import { MagicianDoseTypes } from 'app/constants/Products';

const doseTypeNames = {
  [MagicianDoseTypes.Standard]: 'Standard Dose',
  [MagicianDoseTypes.Micro]: 'Microdose',
};

export default doseTypeNames;
